<template>
  <div class="online-renewal-email-verification">
    <v-container>
      <v-layout row wrap>
        <v-flex md12>
          <center>
            <h1 class="start-title">Verification</h1>
            <v-layout v-if="!emailSent">
                <v-flex md4 offset-md4>
                
                    <p>Please enter the email address associated with your policy</p>
                    <v-layout>
                        <v-flex md8 offset-md2>
                            <v-text-field
                            label="Email Address"
                            placeholder="Enter your email address here"
                            v-model="emailAddress"
                            ></v-text-field>
                            <button class="green-button"
                            v-if="emailAddress"
                            @click="validateEmail()">Continue</button>
                        </v-flex>
                    </v-layout>

                </v-flex>
            </v-layout>

            <v-layout>
                <v-flex md12>
                    <v-layout>
                        <v-flex md6 offset-md3>
                            <v-card v-if="emailSent" class="email-sent-card">
                                <v-layout>
                                    <v-flex md8 offset-md2>
                                        
                                        <div class="icon">
                                            <IconBase><IconEmail /></IconBase>
                                        </div>
                                        <p>
                                            We have sent an email to the address you gave us. Please click the link in the email to verify your identity and create a new password. you can close this window after you receive your email.
                                        </p>
                                        <p>
                                            <a style="cursor: pointer;" @click="createAdminProfileAndSendEmail()">I didn't receive an email.</a>
                                        </p>

                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
          </center>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style lang="css" scoped>
.online-renewal-email-verification {
  background-color: white;
  min-height: 64vh;
}
.start-title {
  color: #d93b20;
  font-weight: bolder;
  margin: 60px auto 20px auto;
}
.email-sent-card {
    padding: 10% 0;
}
.icon {
    background: #f2f8fb;
    border-radius: 100%;
    color: #0072BC;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 72px;
    width: 72px;
    margin: 20px auto;
    font-size: 24px;
    font-weight: bolder;
}
</style>

<script>
export default {
    data() {
        return {
            emailAddress: null,
            emailSent: false
        }
    },
    methods: {
        async validateEmail() {
            if(this.emailAddress) {
                if(this.$store.state.sessionDetails.properties.email !== this.emailAddress) {

                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: 'This is not a valid reference id and email combination!'
                    })

                } else {

                    let payload = {
                        method: 'get',
                        url: `${this.baseURL}/api/cfa/get_cfa_customer_by_email.json`,
                        params: {
                            email: this.emailAddress
                        }
                    },
                    response = await this.$store.dispatch('fetchData', payload);
                    
                    if(response.data.items) {
                        if(response.data.items.results.length > 0) {
                            this.setCustomerDetails(response);
                        } else {
                            Swal.fire({
                                type: 'error',
                                title: 'Oops...',
                                text: 'Something went wrong, please try again.'
                            })
                        }
                    } else {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: 'Something went wrong, please try again.'
                        })
                    }

                }
            }
        },
        setCustomerDetails($response) {
            this.$store.commit('mutate', {
                property: 'customerDetails',
                value: $response.data.items.results[0]
            })
            this.checkIfCustomerHasAdminProfile();
        },
        async checkIfCustomerHasAdminProfile() {
            let adminProfile = this.$store.state.customerDetails.profiles.filter(data => {
                return data.profile_type === "modules/fdca-cfa/cfa_admin";
            });
            if(adminProfile.length === 0 || this.isInvalid(adminProfile[0].properties.password_token)) {
                this.createAdminProfileAndSendEmail();
            } else {
                this.checkIfUserIsLoggedIn();
            }
        },
        async checkIfUserIsLoggedIn() {
            let payload = {
                method: 'get',
                url: `${this.baseURL}/api/cfa/check_if_user_logged_in.json`
            },
            response = await this.$store.dispatch('fetchData', payload);
            if(this.emailAddress === response.data.email) {
                this.$store.commit('mutate', {
                    property: 'onlineRenewalEmail',
                    value: response.data.email
                });
                this.$router.push(`/renewals/${this.$store.state.onlineRenewalQuoteReferenceId}`);
            } else {
                window.location.href = `member/login?quote_reference_id=${this.$store.state.onlineRenewalQuoteReferenceId}&email=${this.emailAddress}`;
            }
        },
        async createAdminProfileAndSendEmail() {
            let payload = {
                method: 'get',
                url: `${this.baseURL}/api/cfa/update_customer_add_cfa_admin_profile.json`,
                params: {
                    id: this.$store.state.sessionDetails.user_id,
                    quote_reference_id: this.$store.state.onlineRenewalQuoteReferenceId
                }
            },
            response = await this.$store.dispatch('fetchData', payload);
            
            this.emailSent = true;
        }
    }
}
</script>
